import { useEffect, useState } from "react";

export default function AutocompleteInput({
  placeholder,
  url,
  onSelect,
  displayKey = "name",
  valueKey = "id"
}) {
  const [query, setQuery] = useState("");
  const [list, setList] = useState([]);
  const [loading, setLoading] = useState(false);

  // 🔥 DEBOUNCE
  useEffect(() => {
    const delay = setTimeout(() => {
      if (query.length < 3) {
        setList([]);
        return;
      }

      fetchData();
    }, 400);

    return () => clearTimeout(delay);
  }, [query]);

  const fetchData = async () => {
    setLoading(true);

    const res = await fetch(`${process.env.REACT_APP_BASE_URL}${url}?q=${query}`);
    const json = await res.json();

    setList(json.data);
    setLoading(false);
  };

  return (
    <div className="relative">
      <input
        type="text"
        placeholder={placeholder}
        className="w-full border p-2 rounded-2xl "
        value={query}
        onChange={(e) => setQuery(e.target.value)}
      />

      {/* DROPDOWN */}
      {list.length > 0 && (
        <div className="absolute z-50 bg-white border w-full max-h-40 overflow-auto rounded shadow">
          {list.map((item) => (
            <div
              key={item[valueKey]}
              onClick={() => {
                setQuery(item[displayKey]);
                setList([]);
                onSelect(item);
              }}
              className="p-2 hover:bg-gray-100 cursor-pointer z-50"
            >
              {item[displayKey]}
            </div>
          ))}
        </div>
      )}

      {loading && (
        <div className="absolute right-2 top-2 text-xs text-gray-400">
          loading...
        </div>
      )}
    </div>
  );
}